import React, { useState, useEffect } from 'react';
import { FaCamera, FaTimes, FaTrashAlt, FaSave, FaChevronLeft, FaChevronRight, FaUser, FaBirthdayCake, FaMapMarkerAlt, FaHome, FaEnvelope } from 'react-icons/fa';
import Navbar from '../home/Navbar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_END_POINT } from './Utils/Constant';
import userimg1 from "../assets/Usersimg/illustration-01.png";
import userimg2 from "../assets/Usersimg/illustration-02.png";
import userimg3 from "../assets/Usersimg/illustration-03.png";
import userimg4 from "../assets/Usersimg/illustration-04.png";
import userimg5 from "../assets/Usersimg/illustration-05.png";
import userimg6 from "../assets/Usersimg/illustration-06.png";
import userimg7 from "../assets/Usersimg/illustration-07.png";
import userimg8 from "../assets/Usersimg/illustration-08.png";

const UserProfile = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    gender: 'Male',
    pincode: '',
    dateOfBirth: '',
    timeOfBirth: '',
    placeOfBirth: '',
    email: '',
    profileImage: userimg1 
  });

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showImageSlider, setShowImageSlider] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);


  const profileImages = [
    userimg1, userimg2, userimg3, userimg4,
    userimg5, userimg6, userimg7, userimg8
  ];

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          alert('Session expired. Please login again.');
          navigate('/login');
          return;
        }

        const headers = {
          'Authorization': token
        };

        // Fetch user profile
        const response = await axios.get(`${API_END_POINT}user/profile`, { headers });
        // console.log('User Profile Response:', response.data); // Debugging log
        const userData = response.data;

        // Update form data with fetched details
        setFormData({
          name: userData.name || '',
          email: userData.email || '',
          gender: userData.gender || 'Male',
          pincode: userData.pincode || '',
          dateOfBirth: userData.dateOfBirth ? userData.dateOfBirth.split('T')[0] : '', // Format date
          timeOfBirth: userData.timeOfBirth || '',
          placeOfBirth: userData.placeOfBirth || '',
          profileImage: profileImages[userData.profileImageIndex || 0]
        });
        setCurrentImageIndex(userData.profileImageIndex || 0);
      } catch (error) {
        console.error('Error fetching user profile:', error);
        if (error.response?.status === 401) {
          alert('Unauthorized access. Please login again.');
          navigate('/login');
        }
      }
    };

    fetchUserProfile();
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageSelect = (index) => {
    setCurrentImageIndex(index);
    setFormData(prev => ({
      ...prev,
      profileImage: profileImages[index]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        alert('Session expired. Please login again.');
        navigate('/login');
        return;
      }

      const updatedData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        gender: formData.gender,
        dateOfBirth: formData.dateOfBirth,
        timeOfBirth: formData.timeOfBirth,
        placeOfBirth: formData.placeOfBirth,
        currentAddress: formData.currentAddress,
        city: formData.city,
        pincode: formData.pincode,
        profileImageIndex: currentImageIndex
      };

      const response = await axios.put(
        `${API_END_POINT}profile/update-profile`,
        updatedData,
        {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success) {
        const updatedUser = response.data.user;
        setFormData({
          firstName: updatedUser.firstName || '',
          lastName: updatedUser.lastName || '',
          gender: updatedUser.gender || 'Male',
          dateOfBirth: updatedUser.dateOfBirth || '',
          timeOfBirth: updatedUser.timeOfBirth || '',
          placeOfBirth: updatedUser.placeOfBirth || '',
          currentAddress: updatedUser.currentAddress || '',
          city: updatedUser.city || '',
          pincode: updatedUser.pincode || '',
          email: updatedUser.email || '',
          profileImage: profileImages[updatedUser.profileImageIndex || 0]
        });
        setCurrentImageIndex(updatedUser.profileImageIndex || 0);
        alert('Profile updated successfully!');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      alert(error.response?.data?.message || 'Failed to update profile');
    }
  };

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem('authToken');
      await axios.delete(`${API_END_POINT}profile/delete-profile`, {
        headers: {
          'Authorization': token
        }
      });

      alert('Profile deleted successfully!');
      localStorage.removeItem('authToken');
      navigate('/signup');
    } catch (error) {
      console.error('Error deleting profile:', error);
      alert('Failed to delete profile.');
    }
  };

  // Image Slider Component
  // This component is used to display the image slider for selecting profile pictures
  const ImageSlider = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl p-6 max-w-lg w-full transform transition-all duration-300 scale-100">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-semibold text-gray-800">Select Profile Picture</h3>
          <button
            onClick={() => setShowImageSlider(false)}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          >
            <FaTimes size={20} />
          </button>
        </div>
        <div className="relative">
          <div className="flex items-center justify-center mb-6">
            <div className="w-40 h-40 rounded-full overflow-hidden shadow-lg">
              <img
                src={profileImages[currentImageIndex]}
                alt="Selected Profile"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex items-center justify-between mb-6">
            <button
              onClick={() => setCurrentImageIndex((prev) => (prev - 1 + profileImages.length) % profileImages.length)}
              className="p-3 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              <FaChevronLeft className="text-gray-600" />
            </button>
            <div className="flex space-x-2">
              {profileImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleImageSelect(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${index === currentImageIndex ? 'bg-secondary' : 'bg-gray-300'
                    }`}
                />
              ))}
            </div>
            <button
              onClick={() => setCurrentImageIndex((prev) => (prev + 1) % profileImages.length)}
              className="p-3 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              <FaChevronRight className="text-gray-600" />
            </button>
          </div>
          <button
            onClick={() => {
              handleImageSelect(currentImageIndex);
              setShowImageSlider(false);
            }}
            className="w-full bg-secondary text-white py-3 rounded-lg hover:bg-secondary/90 transition-colors"
          >
            Select This Image
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Navbar />

      <main className="max-w-6xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-secondary to-secondary/80 p-6 text-center">
            <h1 className="text-3xl font-bold text-white">Edit Your Profile</h1>
          </div>

          <div className="p-6 md:p-8">
            {/* Profile Image Section */}
            <div className="flex flex-col items-center mb-8">
              <div className="relative group">
                <div className="w-40 h-40 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden shadow-lg transition-transform duration-300 group-hover:scale-105">
                  <img
                    src={formData.profileImage}
                    alt="Profile"
                    className="w-full h-full object-cover"
                  />
                </div>
                <button
                  onClick={() => setShowImageSlider(true)}
                  className="absolute bottom-2 right-2 bg-secondary text-white p-3 rounded-full shadow-lg hover:bg-secondary/90 transition-all duration-300 transform hover:scale-110"
                >
                  <FaCamera size={20} />
                </button>
              </div>
              <div className="mt-4 bg-gray-100 px-6 py-2 rounded-full">
                <span className="text-gray-700 font-medium">{formData.email}</span>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Personal Information Section */}
                <div className="space-y-6">
                  <h2 className="text-xl font-semibold text-gray-800 border-b pb-2">Personal Information</h2>
                  <div className="space-y-4">
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        readOnly
                        className="w-full px-4 py-2 rounded-lg border-2 border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed"
                      />
                    </div>
                    <SelectField
                      label="Gender"
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                    />
                    <InputField
                      label="Pincode"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleInputChange}
                      icon={<FaMapMarkerAlt className="text-gray-400" />}
                    />
                  </div>

                </div>

                {/* Birth Information Section */}
                <div className="space-y-6">
                  <h2 className="text-xl font-semibold text-gray-800 border-b pb-2">Birth Information</h2>
                  <div className="space-y-4">
                    <InputField
                      label="Date of Birth"
                      name="dateOfBirth"
                      type="date"
                      value={formData.dateOfBirth}
                      onChange={handleInputChange}
                      icon={<FaBirthdayCake className="text-gray-400" />}
                    />
                    <InputField
                      label="Time of Birth"
                      name="timeOfBirth"
                      type="time"
                      value={formData.timeOfBirth}
                      onChange={handleInputChange}
                      icon={<FaBirthdayCake className="text-gray-400" />}
                    />
                    <InputField
                      label="Place of Birth"
                      name="placeOfBirth"
                      value={formData.placeOfBirth}
                      onChange={handleInputChange}
                      icon={<FaMapMarkerAlt className="text-gray-400" />}
                    />
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row justify-between gap-4 pt-8 border-t">
                <button
                  type="button"
                  onClick={() => setShowDeleteConfirm(true)}
                  className="flex items-center justify-center px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-300"
                >
                  <FaTrashAlt className="mr-2" />
                  Delete Profile
                </button>

                <button
                  type="submit"
                  className="flex items-center justify-center px-8 py-3 bg-secondary text-white rounded-lg hover:bg-secondary/90 transition-colors duration-300"
                >
                  <FaSave className="mr-2" />
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full transform transition-all duration-300 scale-100">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-gray-800">Delete Profile</h3>
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="text-gray-400 hover:text-gray-500 transition-colors"
              >
                <FaTimes size={20} />
              </button>
            </div>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete your profile? This action cannot be undone.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Image Slider Modal */}
      {showImageSlider && <ImageSlider />}
    </div>
  );
};

const InputField = ({ label, name, value, onChange, type = "text", icon }) => (
  <div className="relative">
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <div className="relative">
      {icon && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          {icon}
        </div>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full px-4 py-2 rounded-lg border-2 border-gray-200 focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-all duration-300 ${icon ? 'pl-10' : ''
          }`}
      />
    </div>
  </div>
);

const SelectField = ({ label, name, value, onChange }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <select
      name={name}
      value={value}
      onChange={onChange}
      className="w-full px-4 py-2 rounded-lg border-2 border-gray-200 focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-all duration-300"
    >
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Other">Other</option>
    </select>
  </div>
);

export default UserProfile;
